import { defaultNamespace, i18n } from '@ukpostbox/frontend-framework';
import EN from './en/translation.json';
import JP from './jp/translation.json';

i18n.addResourceBundle('en', defaultNamespace, EN);
i18n.addResourceBundle('jp', defaultNamespace, JP);
